import transactionService from 'Services/TransactionService'

// initial state
const state = {
  transactions: []
}

// getters
const getters = {
  transaction: state => reference => state.transactions.find(transaction => transaction.transactionReference === reference)
}

const actions = {
  filterTransactions: ({ commit }, { context, filterContext }) => {
    const { request, cancelToken } = transactionService.getAll(context, filterContext)

    const promise = new Promise((resolve, reject) => {
      request.then((result) => {
        commit('setTransactions', result.data)
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })

    return { promise, cancelToken }
  },

  getTransactions: ({ dispatch }, { context }) => {
    return dispatch('filterTransactions', { context }).then(({ promise }) => promise.then(result => result.data))
  },

  getTransaction: ({ commit }, { context, transactionId }) => {
    return new Promise((resolve, reject) => {
      transactionService.get(context, transactionId).then(result => {
        commit(state.transactions.some(item => item.transactionReference === result.transactionReference) ? 'updateTransaction' : 'setTransaction', result)
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateTransaction: ({ dispatch }, { context, transactionId, transaction }) => {
    return new Promise((resolve, reject) => {
      transactionService.update(context, transactionId, transaction).then(() => {
        return dispatch('getTransaction', { context, transactionId }).then(result => resolve(result))
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// mutations
const mutations = {
  setTransactions (state, transactions) {
    state.transactions = transactions
  },

  setTransaction (state, transaction) {
    state.transactions.push(transaction)
  },

  updateTransaction (state, transaction) {
    state.transactions = state.transactions.map(item =>
      item.transactionReference === transaction.transactionReference ? transaction : item
    )
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
